import { type ToastInput, useToast } from '@agentic/ui-kit';
import { useEffect } from 'react';
import { notify } from './notify.ts';
import { errorExplanation } from './presentation.ts';
import { errorParts } from './route-states.tsx';

/**
 * The toast of a thrown value, worded by the presentation dictionary: problem as the title, effect and next step
 * below, the reference when the server sent one, and the code under "Technical details". The error's own message
 * is never shown (it may hold driver text or hostnames). A `title` override ("Export failed") moves the problem
 * sentence into the description.
 */
export function errorToast(error: unknown, title?: string): ToastInput {
  const { code, traceId } = errorParts(error);
  const text = errorExplanation(code);
  return {
    title: title ?? text.problem,
    description: title === undefined ? text.effect : `${text.problem} ${text.effect}`,
    next: text.next,
    code,
    ...(traceId ? { traceId } : {}),
    tone: 'bad',
  };
}

/** Forwards `notify` (non-React code) to the toast provider; errors go through `errorToast`. */
export function ToastBridge() {
  const toast = useToast();
  useEffect(
    () =>
      notify.subscribe((item) => {
        if ('error' in item) toast.push(errorToast(item.error, item.title));
        else toast.push(item);
      }),
    [toast],
  );
  return null;
}
